<div [id]="idElement" class="know-more-content mid-gray-bg-xp" [ngClass]="{'is-even light-gray-bg-xp': isEven, 'is-other': isOther}" [style.backgroundColor]="component?.background_color">
    <app-image [path]="img ? img : data.image" [title]="title ? title : data.text" [alt]="altText || data.alt_text"></app-image>
    <div class="know-more-wrapper" #ref><ng-content ></ng-content></div>
    <div class="know-more-wrapper" *ngIf=" ! ref.children.length">
        <div class="title">
            <h2 [innerHTML]="title || data.text | htmlParse"></h2>
        </div>
        <div class="subtitle" [innerHTML]="text || data.description | htmlParse"></div>
        <div *ngIf="link || data.button">
            <a *ngIf="isExternalLink"
               [href]="externalHref"
               class="buttonChanger black-bg-xp"
               [style]="{'background-color': data?.button.background, 'color': data?.button.text_color}">
                {{ data.button.text }}
            </a>
            <a *ngIf="!isExternalLink"
               [routerLink]="internalLink"
               queryParamsHandling="preserve"
               class="buttonChanger black-bg-xp"
               [style]="{'background-color': data?.button.background, 'color': data?.button.text_color}">
                {{ data.button.text }}
            </a>
        </div>
    </div>
</div>
